import type { FaireProductEntity } from "../../entity_types/product";

export const p_tc9nhzp7a6: FaireProductEntity = {
  token: "p_tc9nhzp7a6",
  type: "product",
  name: "Modern Scandinavian Baking",
  brandToken: "b_14eeavl3ro",
  brandName: "Sourcebooks",
  imageUrl:
    "https://cdn.faire.com/fastly/dacae1a2b9015996a1aed422e8680c3715e9f529841bd10f6664948332c68555.jpeg",
  galleryImageUrls: [],
  priceDollars: 8.49,
  description:
    "Master the art and heart of Scandinavian baking—60+ authentic recipes \rNow you can whip up a slice of Scandinavian hospitality in the comfort of your own kitchen! Modern Scandinavian Baking is a complete guide for bakers of all levels who want to create the sweet and savory treats of Denmark, Norway, and Sweden. \rFrom breads, to pastries, cakes, and cookies, there’s a simple and scrumptious recipe to delight everyone in this beautifully designed Scandinavian cookbook. Enjoy contemporary takes on classic bakes, plus a comprehensive guide to stocking your pantry with Scandinavian staples, like rye flour, cardamom, baker’s ammonia, and beyond. \rThis Scandinavian cookbook includes:  Baker’s dozen—Discover 13 simple rules for achieving the best results with the recipes in this Scandinavian cookbook.\r Regional basics—Learn Scandinavian baking foundations, from the cultural origins of cornerstone foods, to techniques like kneading dough, and essential tools like potato ricers, rolling pins, a",
  tags: [],
  msrpDollars: 16.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:02.555Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
